module.exports = __webpack_public_path__ + "static/media/without-classrooms.ecf1de2f.svg";